import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 */
export const SerpSellingPriceRoot = styled(Box)(({ theme }) => {
  const tableStyles = approvalFormTableStyles(theme);
  return {
    width: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    '& table': {
      ...tableStyles,
      tableLayout: 'auto',
      [theme.breakpoints.down('md')]: {
        minWidth: 0,
      },
    },
    // 모바일에서 「상세 보기」 버튼이 화면 밖으로 밀리지 않게 상세 표만 가로 스크롤
    '& table.sales-table': {
      minWidth: 640,
    },
    '& table th, & table td': {
      textAlign: 'center',
    },
    '& thead td': tableStyles['& th'],
    '& table .text-left': {
      textAlign: 'left',
    },
    '& table .text-right': {
      textAlign: 'right',
    },
    '& .mb-0': {
      marginBottom: 0,
    },
    '& .mb-20': {
      marginBottom: 16,
    },
    '& .mb-30': {
      marginBottom: 24,
    },
    '& .table-area': {
      overflowX: 'auto',
    },
  };
});
